import { Component, Input, Output, EventEmitter } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'lc-sidebar, [lcSidebar]',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './lc-sidebar.html',
  styleUrl: './lc-sidebar.scss'
})
export class lcSidebar {
  @Input() navItems: { label: string; path: string }[] = [];
  @Input('sidebar-dark') sidebarDark = false;
  @Output() linkClicked = new EventEmitter<void>();

  onLinkClick() {
    this.linkClicked.emit();
  }
}
